import React from 'react';
import PropTypes from 'prop-types';

const DownloadIcon = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg version="1.1" id="download" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24" {...other}>
      <path fill="none" d="M0,0h24v24H0V0z" />
      <g>
        <path fill={color} d="M14.9,15.7l-2,2V12c0-0.5-0.3-0.9-0.9-0.9c-0.5,0-0.9,0.3-0.9,0.9v5.8l-2-2c-0.3-0.3-0.9-0.3-1.2,0c-0.3,0.3-0.3,0.9,0,1.2
            l3.5,3.5c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.3,0.1,0.3,0.1c0.1,0,0.3,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.2l3.5-3.5
            c0.3-0.3,0.3-0.9,0-1.2C15.7,15.4,15.2,15.4,14.9,15.7z"/>
        <path fill={color} d="M21.5,10.8c-1-1.4-2.5-2.3-4.3-2.3l0,0h-0.4c-1.3-3.8-5.4-6-9.3-5c-4.3,1-6.8,5.3-5.7,9.5c0.3,1.2,0.9,2.4,1.7,3.2
            c0.3,0.3,0.9,0.4,1.2,0.1c0.3-0.3,0.4-0.9,0.1-1.2c-0.6-0.7-1.1-1.6-1.3-2.5C2.6,9.4,4.7,6,7.9,5.2c3.2-0.9,6.6,1.1,7.4,4.4
            c0.1,0.3,0.4,0.7,0.9,0.7h1l0,0c1.1,0,2.2,0.5,2.9,1.5c1.1,1.6,0.7,3.8-0.9,4.9c-0.4,0.3-0.5,0.8-0.2,1.2c0.2,0.3,0.4,0.3,0.7,0.3
            c0.2,0,0.3-0.1,0.5-0.2c1.1-0.8,1.9-2,2.2-3.4C22.6,13.3,22.3,11.9,21.5,10.8z"/>
      </g>
    </svg>
  );
}

DownloadIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

DownloadIcon.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default DownloadIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Download.jsx